module.exports = __webpack_public_path__ + "img/img_joinstep_audit.cfc63a8c.svg";